import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-user-menu',
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule
  ],
  template: `
    <button mat-button [matMenuTriggerFor]="menu" class="flex items-center gap-2 text-white">
      <mat-icon>account_circle</mat-icon>
      <span class="hidden md:inline">Mi cuenta</span>
    </button>

    <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
      <button mat-menu-item (click)="goTo('/account')">
        <mat-icon>person</mat-icon>
        <span>Perfil</span>
      </button>
      <button mat-menu-item (click)="goTo('/account/people')">
        <mat-icon>group</mat-icon>
        <span>Personas</span>
      </button>
      <button mat-menu-item (click)="goTo('/account/tickets')">
        <mat-icon>confirmation_number</mat-icon>
        <span>Mis pasajes</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon color="warn">logout</mat-icon>
        <span class="text-red-600">Cerrar sesión</span>
      </button>
    </mat-menu>
  `
})
export class UserMenuComponent {
  authService = inject(AuthService);
  router = inject(Router);

  goTo(route: string) {
    this.router.navigateByUrl(route);
  }

  logout() {
    this.authService.logout().then(() => {
      this.router.navigateByUrl('/');
    });
  }
}
